import Styles from "../csuite-videos/Csuitevideos.module.scss";
import { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import ButtonWithLink from "../buttons/ButtonWithLink";
import { truncateText } from "../../helper-fuction/helper";
import { urls } from "../../utils/urls";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";

export default function Csuitevideos({ boardTheme = false }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages] = useState(0);
  const [isAtBeginning, setIsAtBeginning] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const [screen, setScreenWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    setScreenWidth(screen);
  }, [screen]);

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const fetchData = async (page) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setIsLoadingMore(true);
      }
     
     // const result = await getWisdomData(page);
     const result= [
      { id: 401, title: 'They Told Me to Focus on the Baby… I Chose to Lead ', url: 'https://www.youtube.com/embed/sfHZriNVsMU'},
      { id: 402, title: 'HR is Not Just About People. Its About Business - Nithya Chandar', url: 'https://www.youtube.com/embed/7ZS7mw_4lC8'},
      { id: 403, title: 'Gunjan Singh’s Bold Move to the ₹1 CR Club ', url: 'https://www.youtube.com/embed/GCqjoQOLDlU'},
      { id: 404, title: 'From Its not for a women to Its My ₹5 CR Business ', url: 'https://www.youtube.com/embed/t_BCDiMWubs'},
      { id: 405, title: 'They Doubted Me, But I Became a Tech Leader ', url: 'https://www.youtube.com/embed/zbl5cQUonCM'},
      { id: 406, title: 'Software Engineer to $4 Million in Revenue Entrepreneur in 2 Year ', url: 'https://www.youtube.com/embed/KWJx0wQAq4E'},
      { id: 407, title: 'One Decision That Changed My life ', url: 'https://www.youtube.com/embed/PfLLQzB90Jw'},
     { id: 408, title: 'How I Built a Powerful Legal Career', url: 'https://www.youtube.com/embed/GOyWuM1dM-g'},
     { id: 409, title: 'HE said I cant handle tough jobs because I am soft-spoken Woman', url: 'https://www.youtube.com/embed/lvHcGgv-cvI'},  
  ];
      setData((prevData) => [...prevData, ...result]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (page === 1) {
        setLoading(false);
      } else {
        setIsLoadingMore(false);
      }
    }
  };

  const slidesPerView = Math.min(3, data.length);
  const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".my-swiper-button-next",
      prevEl: ".my-swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: slidesPerView,
      },
    },
  };

  const handleLoadMore = () => {
    setIsAtEnd(false);
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevClick = () => {
    const swiper = document.querySelector(".my-swiper-container-comp3").swiper;
    swiper.slidePrev();
    setIsAtEnd(false);
    if(screen > 768){
      if (data.length <= 3){
        setIsAtEnd(true);
      } else {
        setIsAtEnd(false);
      }
    }else{
      if (data.length <= 1){
        setIsAtEnd(true);
      } else {
        setIsAtEnd(false);
      }
    } 
  };

  const handleNextClick = () => {
    const swiper = document.querySelector(".my-swiper-container-comp3").swiper;
    swiper.slideNext();
    setIsAtBeginning(false);
    if(screen > 768){
      if (data.length <= 3) {
        setIsAtBeginning(true);
      } else {
        setIsAtBeginning(false);
      }
    }else{
      if (data.length <= 1) {
        setIsAtBeginning(true);
      } else {
        setIsAtBeginning(false);
      }
    }  
  };

  return (
    <div className={`${Styles["main-parent-div"]}${boardTheme ? ` ${Styles["board-theme"]}` : ""}`}>
      {data.length > 0 && (
        <span className={Styles["main-title"]}>C-Suite Conversations</span>
      )}

      {data.length > 0 && (
        <div className={Styles["bullatin-container"]}>
          {loading ? (
            <ThreeCircles
              height="70"
              width="70"
              color="#F52929"
              wrapperStyle={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "20vh",
              }}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
            />
          ) : (
            <>
              {data.length !== 0 ? (
                <>
                  <img
                    alt=""
                    src={urls.prevArrow}
                    className={
                      isAtBeginning ? Styles["disabled"] : Styles["prev"]
                    }
                    onClick={handlePrevClick}
                  ></img>

                  <Swiper
                    {...swiperOptions}
                    className="my-swiper-container-comp3"
                    onReachBeginning={() => {
                      setIsAtBeginning(true);
                    }}
                    onReachEnd={() => {
                      setIsAtEnd(true);
                    }}
                  >
                    {data.map((item) => {
                      return (
                        <SwiperSlide key={item.id}>
                          <div
                            key={item.id}
                            className={Styles["bullatin-card"]}
                           
                          >
                            <div className={Styles["bullatin-top"]}>
                              
                            <iframe
                                    className={Styles["iframe"]}
                                    title="youtube Video Player"
                                    allowFullScreen
                                    src={
                                      item.url
                                    }
                                    id={item.id}
                                  ></iframe>
                              
                            </div>
                            <div className={Styles["bullatin-bottom"]}>
                              <span className={Styles["bullatin-heading"]}>
                                {truncateText(item?.title, 90)}
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}

                    {currentPage < totalPages && (
                      <SwiperSlide>
                        <div className={Styles["load-more-div"]}>
                          <ButtonWithLink
                            linkTo="action"
                            callback={handleLoadMore}
                            name={isLoadingMore ? "Loading..." : "Load More"}
                            className={"button"}
                            disabled={isLoadingMore}
                          ></ButtonWithLink>
                        </div>
                      </SwiperSlide>
                    )}
                  </Swiper>

                  <img
                    alt=""
                    src={urls.nextArrow}
                    className={isAtEnd ? Styles["disabled"] : Styles["next"]}
                    onClick={handleNextClick}
                  ></img>
                </>
              ) : (
                <div
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  className={Styles["no-data"]}
                >
                  <img
                    alt=""
                    src={urls.noData}
                    className={Styles["no-data-image"]}
                  ></img>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}